import React from 'react';
import { useNavigate } from 'react-router-dom';
import './hero section.css';
import hero640avif from '../../assets/hero-640.avif';
import hero1280avif from '../../assets/hero-1280.avif';
import hero1920avif from '../../assets/hero-1920.avif';
import hero640webp from '../../assets/hero-640.webp';
import hero1280webp from '../../assets/hero-1280.webp';
import hero1920webp from '../../assets/hero-1920.webp';

const HeroSection = ({ onLearnMore }) => {
  const navigate = useNavigate();
  
  return (
    <section className="hero-section-component">
      <div className="hero-section-bg">
        <picture>
          <source 
            media="(max-width: 640px)" 
            srcSet={hero640avif} 
            type="image/avif"
          />
          <source 
            media="(max-width: 1280px)" 
            srcSet={hero1280avif} 
            type="image/avif"
          />
          <source 
            srcSet={hero1920avif} 
            type="image/avif"
          />
          <source 
            media="(max-width: 640px)" 
            srcSet={hero640webp} 
            type="image/webp"
          />
          <source 
            media="(max-width: 1280px)" 
            srcSet={hero1280webp} 
            type="image/webp"
          />
          <source 
            srcSet={hero1920webp} 
            type="image/webp"
          />
          <img 
            src={hero1920webp} 
            alt="Real World Equity Hero Background" 
            className="hero-bg-image"
            fetchPriority="high"
            loading="eager"
          />
        </picture>
      </div>
      <div className="hero-section-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">The Future of Investing</h1>
        <p className="hero-subtitle">
          Institutional-grade cash flow. Blockchain-native access.<br />
          Own tokenized interests in assets leased to national brands
        </p>
        <div className="hero-buttons">
          <button className="hero-cta-primary" onClick={onLearnMore}>Learn More</button>
          <button className="hero-cta-secondary" onClick={() => navigate('/tokenization')}>How it Works</button>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <h3>$200M+</h3>
            <p>Assets Under Management</p>
          </div>
          <div className="stat">
            <h3>400+</h3>
            <p>Active Investors</p>
          </div>
          <div className="stat">
            <h3>70+</h3>
            <p>Premium Assets</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
